import { CacheModule } from '@/utils/commonUtils'
import { checkCoupon } from '@/model/javaApi/present.js'
import router from '@/router/router'
import Vue from 'vue'

// 根据卡密（缓存）获取机构信息
const getCheckCoupon = (obj = { secretKey: '' }) => {
  return new Promise((resolve, reject) => {
    const { secretKey } = obj
    if (!secretKey && !CacheModule.get('checkCoupon')) {
      resolve('');
    } else {
      if (secretKey || !CacheModule.get('checkCoupon')) {
        checkCoupon({ ...obj }).then(res => {
          resolve(res);
          CacheModule.set('checkCoupon', { ...res, 'secretKey': secretKey })
        }).catch(err => {
          reject(err)
        })
      } else {
        resolve(CacheModule.get('checkCoupon'))
      }
    }

  })
}

export {
  getCheckCoupon
}


